<template>
  <div class="skill">
    <h2 class="title">{{ title }}</h2>
    <p class="text">{{ text }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    title: { type: String, required: true },
    text: { type: String, required: true }
  }
});
</script>

<style lang="scss" scoped>
.skill {
  .title {
    color: #935e92;
    font-weight: bold;
    margin-bottom: 0.8rem;
  }
  .text {
    color: #293947;
    line-height: 1.5;
  }
}
</style>
